// extracted by mini-css-extract-plugin
export var copyableField = "_r7-4";
export var customerBadge = "_r7-0";
export var customerInfoTitle = "_r7-2";
export var details = "_r7-1";
export var dropdownContainer = "_r7-5";
export var dropdownImage = "_r7-6";
export var editAssigneeForm = "_r7-a";
export var editButton = "_r7-3";
export var email = "_r7-7";
export var hidden = "_r7-d";
export var input = "_r7-8";
export var saveButton = "_r7-b";
export var shopifyIcon = "_r7-c";
export var suggestionBadge = "_r7-e";
export var suggestionText = "_r7-f";
export var username = "_r7-9";